import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicInspection({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M4.77 2a.75.75 0 010 1.5H2.75a.25.25 0 00-.25.25v10c0 .14.11.25.25.25h9c.14 0 .25-.11.25-.25v-3.11a.75.75 0 111.5 0v3.11c0 .97-.78 1.75-1.75 1.75h-9c-.97 0-1.75-.78-1.75-1.75v-10C1 2.78 1.78 2 2.75 2zm4.98 8.8a.75.75 0 110 1.5h-5a.75.75 0 110-1.5zM7.25 8a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5zm3.5-8a4.25 4.25 0 013.5 6.68l1.3 1.3a.75.75 0 11-1.06 1.06l-1.31-1.3A4.25 4.25 0 1110.75 0zm0 1.5a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicInspection.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicInspection.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicInspection svgRef={ref} {...props} />);
export default ForwardRef;
